// Exact labels and values from the existing article form; keep import independent.
export const ARTICLE_IMPORT_TYPES = [
  { value: 1, label: "Artikull i thjeshtë" },
  { value: 2, label: "Gjysëm Produkt" },
  { value: 3, label: "Produkt i Prodhuar" },
];

export const DEFAULT_ARTICLE_IMPORT_TYPE = 1;
// Ledger classification is separate from the production type and absent from Excel.
export const DEFAULT_ARTICLE_IMPORT_LEDGER = 107;
